// extracted by mini-css-extract-plugin
export default {"clientProfileTabs":"Tabs_clientProfileTabs__g8Te3"};